import { render, staticRenderFns } from "./revisitQuestions.vue?vue&type=template&id=e0b91d4a&scoped=true&"
import script from "./revisitQuestions.vue?vue&type=script&lang=ts&"
export * from "./revisitQuestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b91d4a",
  null
  
)

export default component.exports